import React, {useEffect, useState} from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import bulkHelpers from "../../helpers/bulk";

function LabelList(props) {

    const [files, setFiles] = useState(null);
    const [refresh, setRefresh] = useState(false);
    
    const company = props.company + "_bulk";
    const token = props.token;

    useEffect(() => {
        bulkHelpers.downloadList(setFiles, company, token);
    }, [refresh, company, token]);

    return (
        <Box display="flex" flexDirection="column" sx={{mt:"30px"}} className={props.isMobile ? "mobile-box" : "desktop-box"}>
            <Button color="primary" variant="contained" style={{marginTop:"10px", marginBottom:"10px", width:props.isMobile ? "100px" : "50%"}} onClick={()=>setRefresh(!refresh)}>Refresh</Button>
            {files ?
                <TableContainer className={props.isMobile ? "mobile-table-box" : "desktop-table-box"} style={{height: "500px", overflowY:"scroll", width:props.isMobile? "100px":"50%"}}>
                <Table className={props.isMobile ? "mobile-table" : "desktop-table"}  sx={{zIndex:0}}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" style={{fontWeight: "bold"}}>Upload Date</TableCell>
                            <TableCell align="center" style={{fontWeight: "bold"}}>File Name</TableCell>
                            <TableCell align="center"></TableCell>
                            <TableCell align="center"></TableCell>
                        </TableRow>
                    </TableHead>
                    {files.length > 0 ? 
                        <TableBody>
                            {files.length > 0 ? files.map(row => {
                                return(
                                    <TableRow key={row.key} tabIndex={-1}>
                                        <TableCell align="center">{row.date.replace("T", " | ").replace(".000Z", "")}</TableCell>
                                        <TableCell align="center">{row.name}</TableCell>
                                        <TableCell align="center"><Button onClick={()=>bulkHelpers.downloadFile(row.name, company, props.token)} size="small" variant="contained" color="success">Download</Button></TableCell>
                                        <TableCell align="center"><Button onClick={()=>bulkHelpers.downloadData(row.name, company, props.token)} size="small" variant="ctonained" color="secondary">Data</Button></TableCell>
                                    </TableRow> 
                                )
                            }) : null}
                        </TableBody>
                    : <TableBody />}
                </Table>
                </TableContainer>
            : null}
        </Box>
    )
}

export default LabelList;